import { Breadcrumbs } from "../components/global/Breadcrumbs"
import { CustomButton } from "../components/global/CustomButton"
import "./404.css"

export function ErrorPage() {
    return (
        <div className="error-404 mx-auto">
            <div className="my-5">
                <Breadcrumbs dynamicPath="404 Error" />
            </div>

            <div className="d-flex flex-column align-items-center">
                <div className="error-text mt-5 mb-3">404 Not Found</div>
                <div className="mb-5">Your visited page is not found. You may go to home page.</div>

                <CustomButton
                    path="/"
                    color="primary"
                    text="Back to home page"
                />
            </div>
        </div>
    )
}